/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  EmergencyContactDTO,
  FilterFieldsResponse,
  GetApiInstitutionFilterFieldsParams,
  GetApiInstitutionParams,
  InstitutionCreateDTO,
  InstitutionCreateUpdateDTO,
  InstitutionProfileDTO,
  InstitutionViewDTO,
  InstitutionViewDTOPaginationResult,
  PostApiInstitutionIdLogoFullBody,
  PostApiInstitutionIdLogoIconBody,
  ProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiInstitution = (
    params?: GetApiInstitutionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<InstitutionViewDTOPaginationResult>(
      {url: `/api/Institution`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiInstitutionInfiniteQueryKey = (params?: GetApiInstitutionParams,) => {
    return [
    'infinite', `/api/Institution`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiInstitutionQueryKey = (params?: GetApiInstitutionParams,) => {
    return [
    `/api/Institution`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiInstitutionInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitution>>>, TError = ProblemDetails>(params?: GetApiInstitutionParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitution>>> = ({ signal }) => getApiInstitution(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitution>>>
export type GetApiInstitutionInfiniteQueryError = ProblemDetails


export function useGetApiInstitutionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitution>>>, TError = ProblemDetails>(
 params: undefined |  GetApiInstitutionParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitution>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitution>>>, TError = ProblemDetails>(
 params?: GetApiInstitutionParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitution>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitution>>>, TError = ProblemDetails>(
 params?: GetApiInstitutionParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitution>>>, TError = ProblemDetails>(
 params?: GetApiInstitutionParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiInstitutionQueryOptions = <TData = Awaited<ReturnType<typeof getApiInstitution>>, TError = ProblemDetails>(params?: GetApiInstitutionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitution>>> = ({ signal }) => getApiInstitution(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitution>>>
export type GetApiInstitutionQueryError = ProblemDetails


export function useGetApiInstitution<TData = Awaited<ReturnType<typeof getApiInstitution>>, TError = ProblemDetails>(
 params: undefined |  GetApiInstitutionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitution>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitution<TData = Awaited<ReturnType<typeof getApiInstitution>>, TError = ProblemDetails>(
 params?: GetApiInstitutionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitution>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitution<TData = Awaited<ReturnType<typeof getApiInstitution>>, TError = ProblemDetails>(
 params?: GetApiInstitutionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitution<TData = Awaited<ReturnType<typeof getApiInstitution>>, TError = ProblemDetails>(
 params?: GetApiInstitutionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiInstitution = (
    institutionCreateDTO?: InstitutionCreateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<InstitutionViewDTO>(
      {url: `/api/Institution`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: institutionCreateDTO, signal
    },
      options);
    }




export const getPostApiInstitutionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiInstitution>>, TError,{data?: InstitutionCreateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiInstitution>>, TError,{data?: InstitutionCreateDTO}, TContext> => {

const mutationKey = ['postApiInstitution'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiInstitution>>, {data?: InstitutionCreateDTO}> = (props) => {
          const {data} = props ?? {};

          return  postApiInstitution(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiInstitutionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiInstitution>>>
    export type PostApiInstitutionMutationBody = InstitutionCreateDTO | undefined
    export type PostApiInstitutionMutationError = ProblemDetails

    export const usePostApiInstitution = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiInstitution>>, TError,{data?: InstitutionCreateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiInstitution>>,
        TError,
        {data?: InstitutionCreateDTO},
        TContext
      > => {
      return useMutation(getPostApiInstitutionMutationOptions(options), queryClient);
    }
    export const getApiInstitutionFilterFields = (
    params?: GetApiInstitutionFilterFieldsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FilterFieldsResponse>(
      {url: `/api/Institution/filter-fields`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiInstitutionFilterFieldsInfiniteQueryKey = (params?: GetApiInstitutionFilterFieldsParams,) => {
    return [
    'infinite', `/api/Institution/filter-fields`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiInstitutionFilterFieldsQueryKey = (params?: GetApiInstitutionFilterFieldsParams,) => {
    return [
    `/api/Institution/filter-fields`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiInstitutionFilterFieldsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>>, TError = void | ProblemDetails>(params?: GetApiInstitutionFilterFieldsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionFilterFieldsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>> = ({ signal }) => getApiInstitutionFilterFields(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionFilterFieldsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>>
export type GetApiInstitutionFilterFieldsInfiniteQueryError = void | ProblemDetails


export function useGetApiInstitutionFilterFieldsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>>, TError = void | ProblemDetails>(
 params: undefined |  GetApiInstitutionFilterFieldsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionFilterFields>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionFilterFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionFilterFieldsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>>, TError = void | ProblemDetails>(
 params?: GetApiInstitutionFilterFieldsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionFilterFields>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionFilterFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionFilterFieldsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>>, TError = void | ProblemDetails>(
 params?: GetApiInstitutionFilterFieldsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionFilterFieldsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>>, TError = void | ProblemDetails>(
 params?: GetApiInstitutionFilterFieldsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionFilterFieldsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiInstitutionFilterFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError = void | ProblemDetails>(params?: GetApiInstitutionFilterFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionFilterFieldsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>> = ({ signal }) => getApiInstitutionFilterFields(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionFilterFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>>
export type GetApiInstitutionFilterFieldsQueryError = void | ProblemDetails


export function useGetApiInstitutionFilterFields<TData = Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError = void | ProblemDetails>(
 params: undefined |  GetApiInstitutionFilterFieldsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionFilterFields>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionFilterFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionFilterFields<TData = Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError = void | ProblemDetails>(
 params?: GetApiInstitutionFilterFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionFilterFields>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionFilterFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionFilterFields<TData = Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError = void | ProblemDetails>(
 params?: GetApiInstitutionFilterFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionFilterFields<TData = Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError = void | ProblemDetails>(
 params?: GetApiInstitutionFilterFieldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionFilterFields>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionFilterFieldsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiInstitutionCurrent = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<InstitutionProfileDTO>(
      {url: `/api/Institution/current`, method: 'GET', signal
    },
      options);
    }




export const getGetApiInstitutionCurrentInfiniteQueryKey = () => {
    return [
    'infinite', `/api/Institution/current`
    ] as const;
    }

export const getGetApiInstitutionCurrentQueryKey = () => {
    return [
    `/api/Institution/current`
    ] as const;
    }


export const getGetApiInstitutionCurrentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionCurrent>>>, TError = ProblemDetails>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionCurrentInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionCurrent>>> = ({ signal }) => getApiInstitutionCurrent(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionCurrentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionCurrent>>>
export type GetApiInstitutionCurrentInfiniteQueryError = ProblemDetails


export function useGetApiInstitutionCurrentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionCurrent>>>, TError = ProblemDetails>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionCurrent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionCurrentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionCurrent>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionCurrent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionCurrentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionCurrent>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionCurrentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionCurrent>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionCurrentInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiInstitutionCurrentQueryOptions = <TData = Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionCurrentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionCurrent>>> = ({ signal }) => getApiInstitutionCurrent(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionCurrent>>>
export type GetApiInstitutionCurrentQueryError = ProblemDetails


export function useGetApiInstitutionCurrent<TData = Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionCurrent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionCurrent<TData = Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionCurrent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionCurrent<TData = Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionCurrent<TData = Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionCurrent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionCurrentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiInstitutionId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<InstitutionViewDTO>(
      {url: `/api/Institution/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiInstitutionIdInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/Institution/${id}`
    ] as const;
    }

export const getGetApiInstitutionIdQueryKey = (id: string,) => {
    return [
    `/api/Institution/${id}`
    ] as const;
    }


export const getGetApiInstitutionIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionId>>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionIdInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionId>>> = ({ signal }) => getApiInstitutionId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionId>>>
export type GetApiInstitutionIdInfiniteQueryError = ProblemDetails


export function useGetApiInstitutionIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionId>>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionId>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionId>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiInstitutionIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiInstitutionId>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionId>>> = ({ signal }) => getApiInstitutionId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionId>>>
export type GetApiInstitutionIdQueryError = ProblemDetails


export function useGetApiInstitutionId<TData = Awaited<ReturnType<typeof getApiInstitutionId>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionId>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionId<TData = Awaited<ReturnType<typeof getApiInstitutionId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionId>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionId<TData = Awaited<ReturnType<typeof getApiInstitutionId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionId<TData = Awaited<ReturnType<typeof getApiInstitutionId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiInstitutionId = (
    id: string,
    institutionCreateUpdateDTO?: InstitutionCreateUpdateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<InstitutionViewDTO>(
      {url: `/api/Institution/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: institutionCreateUpdateDTO, signal
    },
      options);
    }




export const getPutApiInstitutionIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiInstitutionId>>, TError,{id: string;data?: InstitutionCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiInstitutionId>>, TError,{id: string;data?: InstitutionCreateUpdateDTO}, TContext> => {

const mutationKey = ['putApiInstitutionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiInstitutionId>>, {id: string;data?: InstitutionCreateUpdateDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiInstitutionId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiInstitutionIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiInstitutionId>>>
    export type PutApiInstitutionIdMutationBody = InstitutionCreateUpdateDTO | undefined
    export type PutApiInstitutionIdMutationError = ProblemDetails

    export const usePutApiInstitutionId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiInstitutionId>>, TError,{id: string;data?: InstitutionCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiInstitutionId>>,
        TError,
        {id: string;data?: InstitutionCreateUpdateDTO},
        TContext
      > => {
      return useMutation(getPutApiInstitutionIdMutationOptions(options), queryClient);
    }
    export const deleteApiInstitutionId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/Institution/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiInstitutionIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiInstitutionId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiInstitutionId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiInstitutionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiInstitutionId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiInstitutionId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiInstitutionIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiInstitutionId>>>

    export type DeleteApiInstitutionIdMutationError = ProblemDetails

    export const useDeleteApiInstitutionId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiInstitutionId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiInstitutionId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiInstitutionIdMutationOptions(options), queryClient);
    }
    export const getApiInstitutionIdEmergencyContact = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmergencyContactDTO>(
      {url: `/api/Institution/${id}/emergency-contact`, method: 'GET', signal
    },
      options);
    }




export const getGetApiInstitutionIdEmergencyContactInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/Institution/${id}/emergency-contact`
    ] as const;
    }

export const getGetApiInstitutionIdEmergencyContactQueryKey = (id: string,) => {
    return [
    `/api/Institution/${id}/emergency-contact`
    ] as const;
    }


export const getGetApiInstitutionIdEmergencyContactInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionIdEmergencyContactInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>> = ({ signal }) => getApiInstitutionIdEmergencyContact(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionIdEmergencyContactInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>>
export type GetApiInstitutionIdEmergencyContactInfiniteQueryError = ProblemDetails


export function useGetApiInstitutionIdEmergencyContactInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdEmergencyContactInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdEmergencyContactInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionIdEmergencyContactInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionIdEmergencyContactInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiInstitutionIdEmergencyContactQueryOptions = <TData = Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionIdEmergencyContactQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>> = ({ signal }) => getApiInstitutionIdEmergencyContact(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionIdEmergencyContactQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>>
export type GetApiInstitutionIdEmergencyContactQueryError = ProblemDetails


export function useGetApiInstitutionIdEmergencyContact<TData = Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdEmergencyContact<TData = Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdEmergencyContact<TData = Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionIdEmergencyContact<TData = Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdEmergencyContact>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionIdEmergencyContactQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiInstitutionIdEmergencyContact = (
    id: string,
    emergencyContactDTO?: EmergencyContactDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmergencyContactDTO>(
      {url: `/api/Institution/${id}/emergency-contact`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: emergencyContactDTO, signal
    },
      options);
    }




export const getPatchApiInstitutionIdEmergencyContactMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiInstitutionIdEmergencyContact>>, TError,{id: string;data?: EmergencyContactDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiInstitutionIdEmergencyContact>>, TError,{id: string;data?: EmergencyContactDTO}, TContext> => {

const mutationKey = ['patchApiInstitutionIdEmergencyContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiInstitutionIdEmergencyContact>>, {id: string;data?: EmergencyContactDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiInstitutionIdEmergencyContact(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiInstitutionIdEmergencyContactMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiInstitutionIdEmergencyContact>>>
    export type PatchApiInstitutionIdEmergencyContactMutationBody = EmergencyContactDTO | undefined
    export type PatchApiInstitutionIdEmergencyContactMutationError = ProblemDetails

    export const usePatchApiInstitutionIdEmergencyContact = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiInstitutionIdEmergencyContact>>, TError,{id: string;data?: EmergencyContactDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiInstitutionIdEmergencyContact>>,
        TError,
        {id: string;data?: EmergencyContactDTO},
        TContext
      > => {
      return useMutation(getPatchApiInstitutionIdEmergencyContactMutationOptions(options), queryClient);
    }
    export const getApiInstitutionIdLogoIcon = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/Institution/${id}/logo/icon`, method: 'GET', signal
    },
      options);
    }




export const getGetApiInstitutionIdLogoIconInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/Institution/${id}/logo/icon`
    ] as const;
    }

export const getGetApiInstitutionIdLogoIconQueryKey = (id: string,) => {
    return [
    `/api/Institution/${id}/logo/icon`
    ] as const;
    }


export const getGetApiInstitutionIdLogoIconInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionIdLogoIconInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>> = ({ signal }) => getApiInstitutionIdLogoIcon(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionIdLogoIconInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>>
export type GetApiInstitutionIdLogoIconInfiniteQueryError = ProblemDetails


export function useGetApiInstitutionIdLogoIconInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdLogoIconInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdLogoIconInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionIdLogoIconInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionIdLogoIconInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiInstitutionIdLogoIconQueryOptions = <TData = Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionIdLogoIconQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>> = ({ signal }) => getApiInstitutionIdLogoIcon(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionIdLogoIconQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>>
export type GetApiInstitutionIdLogoIconQueryError = ProblemDetails


export function useGetApiInstitutionIdLogoIcon<TData = Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdLogoIcon<TData = Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdLogoIcon<TData = Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionIdLogoIcon<TData = Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoIcon>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionIdLogoIconQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiInstitutionIdLogoIcon = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/Institution/${id}/logo/icon`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiInstitutionIdLogoIconMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiInstitutionIdLogoIcon>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiInstitutionIdLogoIcon>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiInstitutionIdLogoIcon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiInstitutionIdLogoIcon>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiInstitutionIdLogoIcon(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiInstitutionIdLogoIconMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiInstitutionIdLogoIcon>>>

    export type DeleteApiInstitutionIdLogoIconMutationError = ProblemDetails

    export const useDeleteApiInstitutionIdLogoIcon = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiInstitutionIdLogoIcon>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiInstitutionIdLogoIcon>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiInstitutionIdLogoIconMutationOptions(options), queryClient);
    }
    export const postApiInstitutionIdLogoIcon = (
    id: string,
    postApiInstitutionIdLogoIconBody?: PostApiInstitutionIdLogoIconBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiInstitutionIdLogoIconBody?.file !== undefined) {
 formData.append(`file`, postApiInstitutionIdLogoIconBody.file);
 }

      return customInstance<unknown | null>(
      {url: `/api/Institution/${id}/logo/icon`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostApiInstitutionIdLogoIconMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiInstitutionIdLogoIcon>>, TError,{id: string;data?: PostApiInstitutionIdLogoIconBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiInstitutionIdLogoIcon>>, TError,{id: string;data?: PostApiInstitutionIdLogoIconBody}, TContext> => {

const mutationKey = ['postApiInstitutionIdLogoIcon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiInstitutionIdLogoIcon>>, {id: string;data?: PostApiInstitutionIdLogoIconBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiInstitutionIdLogoIcon(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiInstitutionIdLogoIconMutationResult = NonNullable<Awaited<ReturnType<typeof postApiInstitutionIdLogoIcon>>>
    export type PostApiInstitutionIdLogoIconMutationBody = PostApiInstitutionIdLogoIconBody | undefined
    export type PostApiInstitutionIdLogoIconMutationError = ProblemDetails

    export const usePostApiInstitutionIdLogoIcon = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiInstitutionIdLogoIcon>>, TError,{id: string;data?: PostApiInstitutionIdLogoIconBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiInstitutionIdLogoIcon>>,
        TError,
        {id: string;data?: PostApiInstitutionIdLogoIconBody},
        TContext
      > => {
      return useMutation(getPostApiInstitutionIdLogoIconMutationOptions(options), queryClient);
    }
    export const getApiInstitutionIdLogoFull = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/Institution/${id}/logo/full`, method: 'GET', signal
    },
      options);
    }




export const getGetApiInstitutionIdLogoFullInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/Institution/${id}/logo/full`
    ] as const;
    }

export const getGetApiInstitutionIdLogoFullQueryKey = (id: string,) => {
    return [
    `/api/Institution/${id}/logo/full`
    ] as const;
    }


export const getGetApiInstitutionIdLogoFullInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionIdLogoFullInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>> = ({ signal }) => getApiInstitutionIdLogoFull(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionIdLogoFullInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>>
export type GetApiInstitutionIdLogoFullInfiniteQueryError = ProblemDetails


export function useGetApiInstitutionIdLogoFullInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdLogoFullInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdLogoFullInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionIdLogoFullInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionIdLogoFullInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiInstitutionIdLogoFullQueryOptions = <TData = Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInstitutionIdLogoFullQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>> = ({ signal }) => getApiInstitutionIdLogoFull(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiInstitutionIdLogoFullQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>>
export type GetApiInstitutionIdLogoFullQueryError = ProblemDetails


export function useGetApiInstitutionIdLogoFull<TData = Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdLogoFull<TData = Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>,
          TError,
          Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiInstitutionIdLogoFull<TData = Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiInstitutionIdLogoFull<TData = Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInstitutionIdLogoFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiInstitutionIdLogoFullQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiInstitutionIdLogoFull = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/Institution/${id}/logo/full`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiInstitutionIdLogoFullMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiInstitutionIdLogoFull>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiInstitutionIdLogoFull>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiInstitutionIdLogoFull'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiInstitutionIdLogoFull>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiInstitutionIdLogoFull(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiInstitutionIdLogoFullMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiInstitutionIdLogoFull>>>

    export type DeleteApiInstitutionIdLogoFullMutationError = ProblemDetails

    export const useDeleteApiInstitutionIdLogoFull = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiInstitutionIdLogoFull>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiInstitutionIdLogoFull>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiInstitutionIdLogoFullMutationOptions(options), queryClient);
    }
    export const postApiInstitutionIdLogoFull = (
    id: string,
    postApiInstitutionIdLogoFullBody?: PostApiInstitutionIdLogoFullBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiInstitutionIdLogoFullBody?.file !== undefined) {
 formData.append(`file`, postApiInstitutionIdLogoFullBody.file);
 }

      return customInstance<unknown | null>(
      {url: `/api/Institution/${id}/logo/full`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostApiInstitutionIdLogoFullMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiInstitutionIdLogoFull>>, TError,{id: string;data?: PostApiInstitutionIdLogoFullBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiInstitutionIdLogoFull>>, TError,{id: string;data?: PostApiInstitutionIdLogoFullBody}, TContext> => {

const mutationKey = ['postApiInstitutionIdLogoFull'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiInstitutionIdLogoFull>>, {id: string;data?: PostApiInstitutionIdLogoFullBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiInstitutionIdLogoFull(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiInstitutionIdLogoFullMutationResult = NonNullable<Awaited<ReturnType<typeof postApiInstitutionIdLogoFull>>>
    export type PostApiInstitutionIdLogoFullMutationBody = PostApiInstitutionIdLogoFullBody | undefined
    export type PostApiInstitutionIdLogoFullMutationError = ProblemDetails

    export const usePostApiInstitutionIdLogoFull = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiInstitutionIdLogoFull>>, TError,{id: string;data?: PostApiInstitutionIdLogoFullBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiInstitutionIdLogoFull>>,
        TError,
        {id: string;data?: PostApiInstitutionIdLogoFullBody},
        TContext
      > => {
      return useMutation(getPostApiInstitutionIdLogoFullMutationOptions(options), queryClient);
    }
